<template lang="pug">
.y-map.relative-position
    base-full-spinner(
        v-if="!coords.length || loading")
        template(v-slot:spinner)
            q-spinner-dots(
                size="40px"
                color="positive")
    template(v-if="coords.length")
        .y-map__wrapper.row
            .column.no-wrap.relative-position.bg-grey-5.q-pr-sm(:class="isActivAccessibility ? 'col-sm-12' : 'col-sm-4'")
                .q-px-md.q-mt-md.row.q-mt-xs.justify-between
                    .font-16.text-weight-medium.text-primary
                        | Выберите аптеку
                    city-form(
                        :header="false"
                        :basket="true"
                    )
                .q-pl-md.p.row.q-mt-xs.justify-between.reviewComplite
                    .q-mb-md.row.justify-between.full-width
                        q-checkbox.fav-checkbox(
                            dense
                            v-if="!preorderAvialable && (basket || productPage)"
                            size="34px"
                            color="positive"
                            label="Круглосуточно"
                            v-model="allNight")
                        q-checkbox(
                            dense
                            v-if="userAuthorized"
                            v-model="favourites"
                            size="34px"
                            color="positive"
                            label="Избранные аптеки")
                        q-checkbox(
                            dense
                            v-if="!preorderAvialable && ((basket && !getFromDate) || (productPage && qDs))"
                            size="34px"
                            color="positive"
                            :label="basket ? 'Всё в наличии' : 'Есть в наличии'"
                            :model-value="drugstoreSort"
                            @update:model-value="allAvailable")
                    .q-mb-md.row.q-mt-xs.relative-position.width-55.sorts(v-if="basket || productPage")
                        q-btn-dropdown.text-weight-regular.justify-between.full-width.b-radius-16.border-positive(
                            :rounded="false"
                            no-caps
                            no-wrap
                            color="secondary"
                            :menu-offset="[0, 10]"
                            :label="sortBy.name")
                            q-list.text-positive(separator)
                                template(v-for="(type, key) in sorts")
                                    q-item.justify-between.items-center(
                                        clickable
                                        v-close-popup
                                        @click="sortBy = type")
                                        .row.items-center
                                            .text-primary
                                                | {{ type.name }}
                                            q-icon(
                                                v-if="type.icon"
                                                :name="`img:arrow-${type.icon}.svg`"
                                                color="grey-12"
                                                size="14px").q-ml-sm
                                        q-icon(
                                            v-if="current === key"
                                            name="done"
                                            color="positive"
                                            size="xs")
                        q-icon.dropdown-icon(
                            v-if="sortBy.icon"
                            :name="`img:arrow-${sortBy.icon}.svg`"
                            color="grey-12"
                            size="14px")
                    base-btn.q-mt-xs(
                        v-if="!getFromDate"
                        bradius="20"
                        height="36"
                        width="150"
                        label="Лучшая цена"
                        @click="bestPrice")
                q-scroll-area.col-grow(
                    ref="drugstoreList"
                    class="q-pt-sm q-pr-xs"
                    :thumb-style="options.thumb"
                    :bar-style="options.bar")
                    drugstore-list-desktop(
                        v-for="(item, index) in markers"
                        :index="index"
                        :basket="basket"
                        :drugstore="item"
                        :length="markers.length"
                        :address="item.geo.address"
                        :accessScroll="accessScroll"
                        :cityName="item.geo.city_name"
                        :drugstoreId="item.id"
                        :active="current && current.id === item.id"
                        :userFavouriteDrugstores="userFavouriteDrugstores"
                        @clickDrugstore="clickDrugstore(item)"
                        @closeMap="setDrugstore"
                        @setLoading="loading = $event"
                        @changedFavourites="changedFavourites"
                        @setPosition="setPosition($event)")
                        template(v-slot:bages)
                            .row.full-width.justify-between.text-weight-medium(v-for="badge in getBadges(item.id)"
                                :style="`color: ${badge.color};`")
                                span(v-if="basket") {{ badge.info?.available }}
                                span {{ basket ? badge.info?.price : badge.info }}
            .relative-position(:class="isActivAccessibility ? 'col-sm-0' : 'col-sm-8'")
                .absolute.full-width.q-py-sm.map-buttons.row.no-wrap.q-px-sm(style="z-index: 1;")
                    input.col-8.font-14.q-px-md.q-py-sm.full-height.q-ml-sm.y-map__search(
                        ref="mapSearch"
                        placeholder="Поиск по адресу"
                        v-model="searchMap")
                yandex-map.y-map__container(
                    :coords="coords"
                    :zoom="zoom"
                    :cluster-options="clusterOptions"
                    @map-was-initialized="init"
                    @boundschange="boundschange"
                    ref="ymap")
                    ymap-marker(
                        v-for="(item, index) in markers"
                        :key="Math.random().toString(36).substr(2, 9)"
                        :ref="el => markerItems[item.drugstoreId] = el"
                        :marker-id="item.id"
                        :hint-content="item.geo.address"
                        :coords="[item.geo.location.lat, item.geo.location.lon]"
                        :options="defaultMarker(item, item.id == current?.id)"
                        @click="clickMarker(item)"
                        cluster-name="1")
</template>

<script>
import { deepCopy } from 'assets/helpers';
import { cityes } from 'assets/helpers/cityes';
import { ref, reactive, computed, watch, onMounted } from 'vue';
import { yandexMap, ymapMarker, loadYmap } from 'vue-yandex-maps';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseTabs from 'components/Base/BaseTabs.vue';
import BaseSpiner from 'components/Base/BaseSpiner.vue';
import CityForm from 'components/CityForm/CityForm.vue';
import BaseFullSpinner from 'components/Base/BaseFullSpinner.vue';
import DrugstoreListDesktop from 'src/components/Drugstore/DrugstoreListDesktop.vue';
import DrugstoreFiltersMobile from 'components/Drugstore/DrugstoreFiltersMobile.vue';

export default {
    name: 'BaseDesktopMap',
    props: {
        drugstoreId: {
            type: String,
            default: () => null,
        },
        drugstores: {
            type: Array,
            default: () => [],
        },
        city: {
            type: Object,
            default: () => null,
        },
        currentDrugstore: {
            type: Boolean,
            default: () => false,
        },
        basket: {
            type: Boolean,
            dafault: () => true,
        },
        productPage: {
            type: Boolean,
            default: () => false,
        },
        preorderAvialable: {
            type: Boolean,
            dafault: () => false,
        },
        showList: {
            type: Boolean,
            default: () => true,
        },
        showMap: {
            type: Boolean,
            default: () => true,
        },
        products: {
            type: Array,
        },
        getFromDate: {
            type: Boolean,
            default: () => false,
        },
        drugstoreOnly: {
            type: Boolean,
            default: () => false,
        },
        isOrthopedics: {
            type: Boolean,
            default: () => false,
        },
        qDs: {
            type: Boolean,
            default: () => true,
        },
        isOptics: {
            type: Boolean,
            default: () => false,
        },
    },
    components: {
        BaseBtn,
        BaseTabs,
        CityForm,
        yandexMap,
        ymapMarker,
        BaseSpiner,
        BaseFullSpinner,
        DrugstoreListDesktop,
        DrugstoreFiltersMobile,
    },
    setup(props, { emit }) {
        let instance = null;
        const store = useStore();
        const route = useRoute();

        const favourites = ref(false);
        const inStock = ref();
        const current = ref(null);
        const coords = ref([]);
        const zoom = ref(12);
        const markers = ref();
        const cacheMarkers = {};
        const visible = ref();
        const searchMap = ref('');
        const drugstoreSort = ref(false);
        const scrollPosition = ref(0);
        const verticalPercentage = ref(0);
        const verticalSize = ref(0);
        const accessScroll = ref(true);
        const mapSearch = ref(null);
        const drugstoreList = ref(null);
        const markerItems = ref([]);
        const showDrugstore = ref(false);
        const showDrugstoreFilters = ref(false);
        const loading = ref(false);
        const allNight = ref(false);
        const sortBy = ref({ name: 'Выберите фильтр' });
        const sorts = [{
            name: 'По цене',
            sort: 'sortPriceUp',
            icon: 'up',
        }, {
            name: 'По цене',
            sort: 'sortPriceDown',
            icon: 'down',
        }, {
            name: 'По адресу (А-Я)',
            sort: 'sortNameUp',
            icon: '',
        }, {
            name: 'По адресу (Я-А)',
            sort: 'sortNameDown',
            icon: '',
        }];
        const tabs = ref([
            {
                name: 'map',
                label: 'Карта',
            }, {
                name: 'list',
                label: 'Список',
            },
        ]);
        const options = reactive({
            thumb: {
                borderRadius: '4px',
                backgroundColor: '#D3F2DC',
                width: '8px',
                opacity: 1,
                right: '0',
            },
            bar: {
                borderRadius: '4px',
                backgroundColor: '#fafafa',
                width: '8px',
                opacity: 1,
                right: '0',
            },
        });

        const clusterOptions = {
            1: {
                preset: 'islands#greenCircleDotIconWithCaption',
                clusterIconColor: '#22BD77',
                clusterHideIconOnBalloonOpen: false,
                geoObjectHideIconOnBalloonOpen: false,
                minClusterSize: 3,
                zoomMargin: 2,
            },
        };

        watch(favourites, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(inStock, () => {
            init(instance);
        });

        watch(drugstoreSort, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(() => props.isOrthopedics, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(() => props.isOptics, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(favourites, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(allNight, () => {
            showDrugstoreFilters.value = false;
            init(instance, true);
        });

        watch(scrollPosition, () => {
            scrollTo();
        });

        watch(markers, () => {
            initSearch();
        });

        watch(sortBy, (value) => {
            // сбрасываем активную аптеку
            current.value = null;

            switch (value.sort) {
                case 'sortPriceUp':
                    sortPrice();
                    break;
                case 'sortPriceDown':
                    sortPrice(true);
                    break;
                case 'sortNameUp':
                    sortName();
                    break;
                case 'sortNameDown':
                    sortName(true);
                    break;
            }

            // прокручиваем список вверх
            scrollTop();
        });

        const isActivAccessibility = computed(() => store.getters['styles/isActiv']);

        // способ получения
        const methodWayGet = computed(() => store.getters['basket/BASKET_METHOD_WAY_GET']);

        // значение "забрать сегодня"
        const isToday = computed(() => store.getters['basket/BASKET_IS_TODAY']);

        // товары аптеки
        const drugstoreProductList = computed(() => {
            return props.basket
                ? current.value?.list_items
                : props.products;
        });

        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);

        const userFavouriteDrugstores = computed(() => {
            if(!userAuthorized.value) return null;
            let favs = store.getters['user/USER_FAVOURITE_DRUGSTORES'];
            let ids = [];
            favs.forEach((item) => ids.push(item.id));
            return ids;
        });
        const userCityId = computed(() => store.getters['user/USER_CITY_ID']);

        const allAvailable = () => {
            drugstoreSort.value = !drugstoreSort.value;
        };

        const setVerticalPercentage = (e) => {
            verticalSize.value = e.verticalSize;
            verticalPercentage.value = e.verticalPercentage;
        };

        const clickDrugstore = (item) => {
            current.value = item;
            focus(current.value);
        };

        const clickMarker = (item) => {
            current.value = item;
            focus(current.value);
        };

        const setDrugstore = async () => {
            emit('closeMap');
        };

        // поиск аптеки с лучшей ценой
        const bestPrice = () => {
            if (current.value) {
                document.getElementById(current.value.id)?.classList.remove('drugstore-active');
            }

            if (props.basket) {
                current.value = deepCopy(markers.value).sort((a, b) => {
                    if (a.total_price < b.total_price && a.packing_available >= b.packing_available)
                        return -1;
                })[0];
            } else {
                current.value = deepCopy(markers.value).filter((item) => item.drugstore_price).sort((a, b) => a.drugstore_price - b.drugstore_price)[0];;
            }

            focus(current.value);
        };

        // Инициализация карты
        const init = (localInstance, goScrollTop = false) => {
            instance = localInstance;

            instance.controls.remove('geolocationControl'); // удаляем геолокацию
            instance.controls.remove('searchControl'); // удаляем поиск
            instance.controls.remove('trafficControl'); // удаляем контроль трафика
            instance.controls.remove('typeSelector'); // удаляем тип
            instance.controls.remove('fullscreenControl'); // удаляем кнопку перехода в полноэкранный режим
            instance.controls.remove('zoomControl'); // удаляем контрол зуммирования
            instance.controls.remove('rulerControl'); // удаляем контрол правил

            // Создание маркеров
            markers.value = [...props.drugstores];

            markers.value.sort((a, b) => b.drugstore_balance - a.drugstore_balance);

            // отображаем только избранные аптеки
            if (favourites.value) {
                markers.value = markers.value.filter((item) => userFavouriteDrugstores.value.includes(item.id));
            } else if (props.isOrthopedics) {
                markers.value = markers.value.filter((item) => item.isOrthopedics || item.drugstoreBalance || item.preorder_available);
            } else if (props.isOptics) {
                markers.value = markers.value.filter((item) => item.isOptics || item.drugstoreBalance || item.preorder_available);
            } else if (!props.currentDrugstore) {
                current.value = null;
            }

            // отображение только круглосуточных аптек
            if(allNight.value) {
                markers.value = markers.value.filter((item) => item.isDayAndNight);
            }

            // сортируем аптеки по наличию
            if (drugstoreSort.value) {
                
                markers.value =
                    props.basket
                        ? markers.value.filter((item) => getBadges(item.id)[0]?.status == 4)
                        : markers.value.filter((item) => item.drugstore_balance);
            }

            boundschange();

            markers.value.forEach((drugstore) => {
                if (drugstore.id == props.drugstoreId && props.currentDrugstore) {
                    if(!current.value) current.value = drugstore;
                }
            });

            if (goScrollTop) {
                scrollTop();
            }
        };

        const setPosition = (e) => {
            scrollPosition.value = e;
        };

        const focus = (placemark, search = false) => {

            showDrugstore.value = false;
            let zoom = instance.getZoom() > 12
                ? instance.getZoom()
                : 15;

            if (search) {
                zoom = 12;
            }
            showDrugstore.value = true;

            instance.setCenter([placemark.geo.location.lat - 0.007, placemark.geo.location.lon], 14, {
                duration: 350,
            }).then(() => {
                instance.geoObjects.get(0).getGeoObjects().filter((item) => {
                    const { markerId } = item.properties.getAll();
                    return placemark.id === markerId;
                });
            });

            setTimeout(() => {
                const el = document.querySelector('.ymap-active-marker');
                if (el)
                    el.parentNode.parentNode.style.zIndex = 4000;
            }, 100);
        };

        const changedFavourites = () => {
            init(instance);
        };

        const scrollTop = () => {
            const duration = 250;
            drugstoreList.value?.setScrollPosition('vertical', 0, duration);
        };

        const scrollTo = () => {
            const duration = 500;
            if (verticalPercentage.value < 1) {
                drugstoreList.value?.setScrollPosition('vertical', scrollPosition.value - 1, duration);
            } else if (verticalSize.value - drugstoreList.value.$el.clientHeight > scrollPosition.value) {
                drugstoreList.value?.setScrollPosition('vertical', scrollPosition.value - 1, duration);
            }
        };

        // генерируем бейджи для аптек
        const getBadges = (drugstoreId) => {
            let cache = cacheMarkers[drugstoreId];

            // if (cache) return cache;

            const actualDrugstore = props.drugstores.find((item) => item.id === drugstoreId);

            /**
             * Если карта отображена
             * на странице "Карточка товара"
             */

            if (props.productPage) {
                if(actualDrugstore?.drugstore_balance) {
                    cache = [{
                        status: 3,
                        color: `${actualDrugstore.isPostamatInside ? '#1462A9' : '#0CA551'}`,
                        info: `${actualDrugstore.drugstore_price} р.`,
                        short: `${actualDrugstore.drugstore_price} р.`,
                        label: `<div class="white-space-nowrap text-weight-bold">${new Intl.NumberFormat('ru-RU').format(actualDrugstore.drugstore_price)} р.</div>`,
                        coordinates: [
                            [-42, -66], [42, 0],
                        ],
                        isDayAndNight: actualDrugstore?.isDayAndNight,
                        isPostamatInside: actualDrugstore?.isPostamatInside,
                        isOrthopedics: actualDrugstore?.isOrthopedics,
                        isOptics: actualDrugstore?.isOptics,
                    }];
                } else if (props.drugstoreOnly) {
                    cache = [{
                        status: 2,
                        color: '#ACACAC',
                        info: 'только в аптеке',
                        short: 'только в аптеке',
                        label: '<div class="white-space-nowrap text-weight-bold">только в аптеке</div>',
                        coordinates: [
                            [-37, -66], [57, -10],
                        ],
                        isDayAndNight: actualDrugstore?.isDayAndNight,
                        isPostamatInside: actualDrugstore?.isPostamatInside,
                        isOrthopedics: actualDrugstore?.isOrthopedics,
                        isOptics: actualDrugstore?.isOptics,
                    }];
                } else if (actualDrugstore?.preorder_available) {
                    cache = [{
                        status: 2,
                        color: '#F2C037',
                        info: 'заказать',
                        short: 'заказать',
                        label: '<div class="white-space-nowrap text-weight-bold">заказать</div>',
                        coordinates: [
                            [-47, -66], [47, -10],
                        ],
                        isDayAndNight: actualDrugstore?.isDayAndNight,
                        isPostamatInside: actualDrugstore?.isPostamatInside,
                        isOrthopedics: actualDrugstore?.isOrthopedics,
                        isOptics: actualDrugstore?.isOptics,
                    }];
                } else {
                    cache = [{
                        status: 0,
                        color: '#ACACAC',
                        info: 'нет в наличии',
                        short: 'нет в наличии',
                        label: '<div class="white-space-nowrap text-weight-bold">нет в наличии</div>',
                        coordinates: [
                            [-67, -66], [67, -10],
                        ],
                        isDayAndNight: actualDrugstore?.isDayAndNight,
                        isPostamatInside: actualDrugstore?.isPostamatInside,
                        isOrthopedics: actualDrugstore?.isOrthopedics,
                        isOptics: actualDrugstore?.isOptics,
                    }];
                }
            } else {
                // кол-во выбранных товаров
                const amount = actualDrugstore.list_items.reduce((acum, { available }) => available + acum, 0);

                switch (actualDrugstore.status_code) {
                    case 4: cache = [{
                        status: 4,
                        color: '#0CA551',
                        short: `${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}`,
                        info: {
                            available: `${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}`,
                            price: `${new Intl.NumberFormat('ru-RU').format(
                                isToday.value
                                    ? actualDrugstore.list_items.reduce((totalPrice, { price }) => price + totalPrice, 0)
                                    : actualDrugstore.total_price)} р.`,
                        },
                        label: `
                        <div class="white-space-nowrap text-center">${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}</div>
                        <div class="white-space-nowrap text-weight-bold">${new Intl.NumberFormat('ru-RU').format(actualDrugstore.total_price)} р.</div>`,
                        coordinates: [
                            [-59, -60], [59, 0],
                        ],
                    }];
                        break;
                    case 3: cache = [{
                        status: 3,
                        color: '#F13613',
                        short: `${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}`,
                        info: {
                            available: `${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}`,
                            price: `${new Intl.NumberFormat('ru-RU').format(
                                isToday.value
                                    ? actualDrugstore.list_items.reduce((totalPrice, { price }) => price + totalPrice, 0)
                                    : actualDrugstore.total_price)} р.`,
                        },
                        label: `
                        <div class="white-space-nowrap text-center">${isToday.value ? amount : actualDrugstore.packing_available}/${actualDrugstore.packing_amount}</div>
                        <div class="white-space-nowrap text-weight-bold text-center">${new Intl.NumberFormat('ru-RU').format(
        isToday.value
            ? actualDrugstore.list_items.reduce((totalPrice, { price }) => price + totalPrice, 0)
            : actualDrugstore.total_price)} р.</div>`,
                        coordinates: [
                            [-48, -62], [48, 0],
                        ],
                    }];
                        break;
                    case 2: cache = [{
                        status: 2,
                        color: '#F2C037',
                        short: 'заказать',
                        info: {
                            available: `Всё заказать со склада с ${date}`,
                            price: `${new Intl.NumberFormat('ru-RU').format(actualDrugstore.total_price)} р.`,
                        },
                        label: `Всё заказать со склада с ${date}`,
                        label: `
                        <div class="white-space-nowrap text-weight-bold">Всё заказать со склада с ${date}</div>
                        <div class="white-space-nowrap text-weight-bold text-center">${new Intl.NumberFormat('ru-RU').format(
        isToday.value
            ? actualDrugstore.list_items.reduce((totalPrice, { price }) => price + totalPrice, 0)
            : actualDrugstore.total_price)} р.</div>`,
                        coordinates: [
                            [-81, -52], [81, 0],
                        ],
                    }];
                        break;
                    case 1: cache = [{
                        status: 1,
                        color: '#8C82E4',
                        short: '',
                        info: {
                            available: 'Частично заказать со склада',
                            price: `${new Intl.NumberFormat('ru-RU').format(actualDrugstore.total_price)} р.`,
                        },
                        label: `
                        <div class="white-space-nowrap text-weight-bold">Частично заказать со склада</div>
                        <div class="white-space-nowrap text-weight-bold text-center">${new Intl.NumberFormat('ru-RU').format(actualDrugstore.total_price)} р.</div>`,
                        coordinates: [
                            [-40, -70], [40, 0],
                        ],
                    }];
                        break;
                    case 0: cache = [{
                        status: 0,
                        color: '#ACACAC',
                        short: 'нет в наличии',
                        label: 'Нет в наличии',
                        coordinates: [
                            [-40, -70], [40, 0],
                        ],
                    }];
                        break;
                }
            }

            cacheMarkers[drugstoreId] = cache;

            return cacheMarkers[drugstoreId];
        };

        const initSearch = () => {
            const suggest = (request, options) => {
                const results = [];
                const placemarks = instance?.geoObjects.get(0)?.getGeoObjects()
                    .filter((item) => {
                        const { hintContent } = item.properties.getAll();

                        return hintContent
                            .toLowerCase()
                            .includes(request.toLowerCase());
                    });

                for (let i = 0; i < Math.min(options.results, placemarks?.length); i++) {
                    const { hintContent } = placemarks[i].properties.getAll();

                    results.push({
                        placemark: placemarks[i],
                        displayName: hintContent,
                    });
                }

                return ymaps.vow.resolve(results);
            };

            const suggestView = new ymaps
                .SuggestView(mapSearch.value, {
                    provider: {
                        suggest,
                    },
                });

            suggestView.events
                .add('select', ({ originalEvent }) => {
                    current.value = markers.value.find((item) => {
                        return item.id === originalEvent.item.placemark.properties.getAll().markerId;
                    });

                    focus(current.value);

                    searchMap.value = '';
                });
        };

        const boundschange = () => {
            markers.value.sort((a, b) => b.status_code - a.status_code);

            if (!markers.value.length) visible.value = null;
        };

        const showAllFavourites = (value) => {
            value
                ? markers.value = markers.value.filter((item) => userFavouriteDrugstores.value.includes(item.id))
                : markers.value = [...props.drugstores];
        };

        const defaultMarker = (marker, isCurrent) => {
            let fMarker = getBadges(marker.id)[0];
            
            let logo = null;

            if(fMarker.isOrthopedics && props.isOrthopedics) {
                logo = '<img src="logo_ortop.svg" style="width: 52px; height: 18px; margin-top: 10px;">';
            } else if(fMarker.isOptics && props.isOptics) {
                logo = '<img src="logo_optic.svg" style="width: 52px; height: 18px; margin-top: 10px;">';
            } else if(fMarker.isPostamatInside) {
                logo = '<img src="pvz.svg" style="width: 52px; height: 18px; margin-top: 10px;">';
                // logo = '<div style="width: 52px; margin-top: 10px" class="font-14 line-height-18 text-weight-bold text-center">ПВЗ</div>';
            } else if(fMarker.isDayAndNight)  {
                logo = '<img src="24.svg" style="width: 52px; height: 18px; margin-top: 10px;">';
            } else {
                logo = '<img src="logo_t.t.svg" style="width: 52px; height: 18px; margin-top: 10px;">';
            }

            


            let squareLayout = ymaps.templateLayoutFactory.createClass(
                `<div class="placemark_layout_container ${current.value?.id == marker.id ? 'ymap-active-marker top' : ''}">
                    <div
                        class="polygon_layout b-radius-16 q-py-none q-px-md bg-secondary relative-position"
                        style="color: ${fMarker.color}; border: 2px solid ${fMarker.color}; transform: translate(-50%, calc(-100% - 13px));">
                        <div class="flex justify-center">${logo}</div>
                        <div class="text-center">${fMarker.label}</div>
                        <svg class="absolute-bottom" style="transform: translate(-50%, calc(100% - 1px)); left: 50%;" width="37" height="14" viewBox="0 0 37 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.5 11.5L14.5 7L10 4.5L5 2.5L0 2V0L37 0V2L33 2L25.5 4.5L21.5 7.5L18.5 11.5Z" fill="white"/>
                            <path d="M0.5 2C13 2.00001 18.5 11.9995 18.5 11.9995C18.5 11.9995 24.4052 2.07911 36.2156 2.00001L36.5 2.00001" stroke="${fMarker.color}" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </div>
                    ${current.value?.id == marker.id? `<div class="blob absolute top" style="background: ${fMarker.color};"></div>` : ''}
                </div>`);

            return {
                iconLayout: squareLayout,
                iconShape: {
                    type: 'Rectangle',
                    // Прямоугольник описывается в виде двух точек - верхней левой и нижней правой.
                    coordinates: fMarker.coordinates,
                },
            };
        };

        const sortPrice = (reverse = false) => {
            const proprty = props.basket ? 'total_price' : 'drugstore_price';

            markers.value.sort((a, b) => {
                if (!a[proprty] && !b[proprty]) {
                    return 0;
                } else if (a[proprty] && !b[proprty]) {
                    return -1;
                } else if (!a[proprty] && b[proprty]) {
                    return 1;
                }

                return reverse
                    ? b[proprty] - a[proprty]
                    : a[proprty] - b[proprty];
            });
        };

        const sortName = (reverse = false) => {
            reverse
                ? markers.value.sort((a, b) => b.geo.address.localeCompare(a.geo.address))
                : markers.value.sort((a, b) => a.geo.address.localeCompare(b.geo.address));

        };
        
        // watch(route, () => {
        //     init(instance);
        // });

        onMounted(async () => {
            await loadYmap({
                apiKey: process.env.YMAP_API_KEY,
                lang: 'ru_RU',
                coordorder: 'latlong',
                version: '2.1',
                controls: [],
            });

            if (props.currentDrugstore && props.drugstoreId) {
                const drugstore = props.drugstores
                    .find(({ id }) => id === props.drugstoreId);

                if (drugstore) {
                    coords.value = Object.values(drugstore.geo.location);
                    zoom.value = 15;
                }
            } else {
                if (props.drugstoreId) {
                    const drugstore = props.drugstores
                        .find(({ id }) => id === props.drugstoreId);

                    if (drugstore) {
                        coords.value = Object.values(drugstore.geo.location);
                        zoom.value = 14;
                    }
                } else {
                    let coordinates = null;

                    if (!props.city) {
                        let result = await store.dispatch('cityForm/GET_CITY_BY_ID', {
                            city_id: userCityId.value,
                        });

                        coordinates = result.coordinates;
                    } else {
                        coordinates = props.city.coordinates;
                    }

                    if (coordinates) {
                        coords.value = [
                            coordinates.lat,
                            coordinates.lon,
                        ];
                    } else {
                        coords.value = [
                            50.6107400,
                            36.5801500,
                        ];
                    }
                };
            }
        });

        return {
            tabs,
            init,
            zoom,
            sorts,
            sortBy,
            coords,
            markers,
            options,
            visible,
            current,
            loading,
            allNight,
            searchMap,
            getBadges,
            mapSearch,
            bestPrice,
            userCityId,
            favourites,
            markerItems,
            setPosition,
            clickMarker,
            boundschange,
            setDrugstore,
            allAvailable,
            accessScroll,
            showDrugstore,
            defaultMarker,
            drugstoreSort,
            drugstoreList,
            userAuthorized,
            clickDrugstore,
            clusterOptions,
            changedFavourites,
            showDrugstoreFilters,
            drugstoreProductList,
            setVerticalPercentage,
            userFavouriteDrugstores,
            isActivAccessibility,
        };
    },
};
</script>


<style lang="scss" scoped>
.y-map {
    position: relative;
    height: 100%;
    border: 1px solid #0000001f;
    border-radius: $button-border-radius;
    overflow: hidden;

    .y-map__wrapper {
        height: 100%;
    }
}

.mobile-map {
    background-color: $secondary;
}

.map-buttons {
    width: 50%;
}

.drugstore-list-block {
    padding-right: 4px;
}

.y-map {
    position: relative;
    height: 100%;
    border: 1px solid $grey-8;
    border-radius: $button-border-radius;
    overflow: hidden;

    &__search {
        width: 300px;
        outline: none;
        border-radius: 30px;
        box-shadow: 0 1px 5px rgb(0 0 0 / 20%);
        border: 2px solid $positive;
        padding: 12px;

        // background: url("/search.svg") no-repeat left;
        // background-size: contain;

        &:focus {
            border: 1px solid $positive;
        }

        @media screen and (max-width: 320px) {
            max-width: 160px;
        }
    }

    &__container {
        width: 100%;
        height: 100%;
        border-left: 1px solid $grey-8;
        overflow: hidden;

        & .ymaps-2-1-78-balloon,
        & .ymaps-2-1-78-balloon > :first-child {
            border-radius: $button-border-radius;

            & .ymaps-2-1-78-balloon__close .ymaps-2-1-78-balloon__close-button {
                margin: 0 5px;
            }
        }
    }
}

:deep(ymaps[class*="search__suggest"]) {
    top: 5px;
    border-radius: $button-border-radius;
    width: 100%;
    font-size: 14px;
}

:deep(ymaps[class*="search__suggest-item_selected_yes"]) {
    background-color: $positive;
    color: $secondary;
    border-radius: 0;
}

:deep(.placemark_layout_container) {
    position: relative;
}

:deep(.polygon_layout) {
    position: relative;
    width: fit-content;
    z-index: 99;
}

:deep(.blob) {
	border-radius: 50%;
	height: 14px;
	width: 14px;
    top: -7px;
    left: -7px;
    z-index: 9999;

	box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
	animation: pulse 1.5s infinite;
}

@keyframes pulse {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
	}

	70% {
		transform: scale(1.3);
		box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	}
}

.dropdown-icon {
    position: absolute;
    bottom: 32%;
    left: 20px;
}

.q-checkbox :deep(.q-checkbox__label) {
    font-size: 14px;
    color: $grey-9;
}

.q-checkbox :deep(.q-checkbox__inner) {
    color: $grey-9;
}

.sorts {
    @media screen and (max-width: 1280px) {
        width: 100%;
    }
}

.top {
    z-index: 9999;
}

.q-btn :deep(.q-btn__content) {
    color: $primary;
}

.fav-checkbox :deep(.q-checkbox__label) {
    color: $positive;
}

</style>
